const sideMenuList = [
  {
    id: 1,
    title: "Dashboard",
    route: "/dashboard",
    icon: "mdi mdi-home",
    is_show:'is_dashboard'
  },
  {
    id: 2,
    title: "User Management",
    route: "/user-list",
    icon: "mdi mdi-account",
    is_show:'is_dashboard'
  },
  {
    id: 3,
    title: "Order History",
    route: "/order-history",
    icon: "mdi mdi-cart-variant",
    is_show:'is_dashboard'
  },
  {
    id: 4,
    title: "Main Category",
    route: "/main-category",
    icon: "mdi mdi-history",
    is_show:'is_dashboard'
  },
  {
    id: 5,
    title: "Category",
    route: "/category",
    icon: "mdi mdi-history",
    is_show:'is_dashboard'
  },
  {
    id: 6,
    title: "Sub Category",
    route: "/sub-category",
    icon: "mdi mdi-history",
    is_show:'is_dashboard'
  },
  {
    id: 7,
    title: "Explore",
    route: "/explore",
    icon: "mdi mdi-history",
    is_show:'is_dashboard'
  },
  {
    id: 8,
    title: "Products",
    route: "/product",
    icon: "mdi mdi-package-variant-closed",
    is_show:'is_dashboard'
  },
  {
    id: 9,
    title: "Home Title",
    route: "/home-title",
    icon: "mdi mdi-home",
    is_show:'is_dashboard'
  },
  {
    id: 10,
    title: "Banner",
    route: "/banner",
    icon: "mdi mdi-panorama-variant",
    is_show:'is_banner',
  },
  {
    id: 11,
    title: "FAQ",
    route: "/faq",
    icon: "mdi mdi-frequently-asked-questions",
    is_show:'is_banner',
  },
  {
    id: 12,
    title: "Site Policy",
    route: "/site-policy",
    icon: "mdi mdi-panorama-variant",
    is_show:'is_banner',
  },
  {
    id: 13,
    title: "Social Media",
    route: "/social-media",
    icon: "mdi mdi-panorama-variant",
    is_show:'is_banner',
  },
  {
    id: 14,
    title: "Role Management",
    route: "/role-list",
    icon: "mdi mdi-face-agent",
    is_show:'is_role_management',
  },


];
export default sideMenuList;
